// Remember the member's last in-app location so a cold launch returns them
// there, instead of always bouncing to their role's default shell. Platform
// admins (who can move between /platform, /admin, /trainer, /app) kept landing
// on /platform every launch even when they were last in the member app.
//
// Only in-app shell routes are remembered; public/marketing/auth routes are
// ignored, and route guards (RequireRole) still protect access, so a stale
// saved route can never grant the wrong view.

const KEY = 'tf:lastRoute';
const SHELLS = ['/platform', '/admin', '/trainer', '/app'];

function isShellRoute(path) {
  return typeof path === 'string' && SHELLS.some((s) => path === s || path.startsWith(s + '/'));
}

export function rememberRoute(pathname) {
  if (!isShellRoute(pathname)) return;
  try { localStorage.setItem(KEY, pathname); } catch { /* private mode / no storage */ }
}

export function readLastRoute() {
  try {
    const v = localStorage.getItem(KEY);
    return isShellRoute(v) ? v : null;
  } catch { return null; }
}
